module.exports = require('../../full/object/create');
